/**
 * The carry-over use-by line under a holiday balance (DESIGN-rollover.md, 09/10/2026):
 * "Includes 5 carried-over days. Use 3 more by 31/03/2027 (days off on or before that
 * date) or they'll be lost." — or, once they're all booked, a green tick.
 *
 * ⚠️ Nothing at all after the date (Rob: "a constant kick in the teeth"). The wording and
 * the rules live in lib/carryOver.js, checked by carryOver.checks.mjs.
 */
import React from 'react';
import { CheckCircle2, Hourglass } from 'lucide-react';
import { carryLine } from '../lib/carryOver';

// `aboutSomeoneElse`: an admin or manager looking at an employee's leave page — the same
// facts, without talking to them as "you".
export default function CarryOverLine({ allowance, className = '', aboutSomeoneElse = false }) {
  const line = carryLine(allowance);
  if (!line) return null;
  if (line.tone === 'ok') {
    return (
      <div className={`mt-3 flex items-start gap-2 rounded-md px-2.5 py-2 text-xs bg-green-500/10 text-green-700 dark:text-green-300 ${className}`}
        data-testid="carry-over-line">
        <CheckCircle2 className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
        <span>{aboutSomeoneElse ? 'Their' : 'Your'} {line.carried} {line.verb} all booked before {line.useBy}.</span>
      </div>
    );
  }
  return (
    <div className={`mt-3 flex items-start gap-2 rounded-md px-2.5 py-2 text-xs bg-orange-500/10 text-orange-800 dark:text-orange-200 ${className}`}
      data-testid="carry-over-line">
      <Hourglass className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
      {aboutSomeoneElse ? (
        <span>
          Includes {line.carried}. <strong>{line.toUse} still to use by {line.useBy}</strong> (days
          off on or before that date) or they'll be lost.
        </span>
      ) : (
        <span>
          Includes {line.carried}. <strong>Use {line.more} by {line.useBy}</strong> (days off
          on or before that date) or they'll be lost.
        </span>
      )}
    </div>
  );
}
